export default [
    {
        key: 'EditTenantPopup',
        getComponent: function () { return import('./EditTenantPopup'); },
        width: 400,
        title: '',
        maskClosable: false,
        timeout: 500,
    },
];
